module.exports = __webpack_public_path__ + "images/avatars/female/9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/9.svg
// module id = uaFb
// module chunks = 151